$(() => {
  $('.video-intro .scroll-indicator').on('click', function () {
    let $section = $(this).closest('.page-section')
    if ($section.length === 0) return
    let $nextSection = $section.nextAll('.page-section')
    if ($nextSection.length === 0) return
    $nextSection.get(0).scrollIntoView({ behavior: 'smooth', block: 'start' })
  })
})
